webpackJsonp([123358100903443],{

/***/ 1218:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusAssignmentStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"RESERVED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"OCCUPIED"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-census-assignment-status-dcbb5690351e80801752.js